import { createAction } from "redux-actions";

export const NOTIFICATION_LIST = "NOTIFICATION_LIST";
export const notificationList = createAction(NOTIFICATION_LIST);

export const NOTIFICATION_UNREAD_COUNT = "NOTIFICATION_UNREAD_COUNT";
export const notificationUnreadCount = createAction(NOTIFICATION_UNREAD_COUNT);

export const NOTIFICATION_MARK_READ = "NOTIFICATION_MARK_READ";
export const notificationMarkRead = createAction(NOTIFICATION_MARK_READ);

export const NOTIFICATION_MARK_UNREAD = "NOTIFICATION_MARK_UNREAD";
export const notificationMarkUnread = createAction(NOTIFICATION_MARK_UNREAD);

export const NOTIFICATION_DELETE = "NOTIFICATION_DELETE";
export const notificationDelete = createAction(NOTIFICATION_DELETE);

export const NOTIFICATION_MY_LIST = "NOTIFICATION_MY_LIST";
export const notificationMyList = createAction(NOTIFICATION_MY_LIST);

export const NOTIFICATION_MY_UNREAD_COUNT = "NOTIFICATION_MY_UNREAD_COUNT";
export const notificationMyUnreadCount = createAction(NOTIFICATION_MY_UNREAD_COUNT);

export const NOTIFICATION_MY_MARK_READ = "NOTIFICATION_MY_MARK_READ";
export const notificationMyMarkRead = createAction(NOTIFICATION_MY_MARK_READ);

export const NOTIFICATION_MY_MARK_UNREAD = "NOTIFICATION_MY_MARK_UNREAD";
export const notificationMyMarkUnread = createAction(NOTIFICATION_MY_MARK_UNREAD);

export const NOTIFICATION_MY_DELETE = "NOTIFICATION_MY_DELETE";
export const notificationMyDelete = createAction(NOTIFICATION_MY_DELETE);
